import React from 'react'
import PPVTemplate from 'src/components/page/ppv'
import { promoCodes } from 'src/constants'
import { videoURI } from 'src/modules/utils/constants'

export default (props) => {
  return (
    <PPVTemplate
      lang="en"
      market="us"
      location={props.location}
      title="AEW All In: Texas 2025"
      subtitle="Watch live this Saturday, July 12, on pay per view with Fubo"
      video={videoURI + 'compressed/AEW_AllinTexas_LP_16x9_10s_LowBitrate.mp4'}
      videoMobile={videoURI + 'mobile/AEW_AllinTexas_LP_1x1_10s_LowBitrate.mp4'}
      offerCode={promoCodes.aew_all_in_texas_2025}
      additionalFAQs={additionalFAQs}
      isEventEnded={true}
      platformExcludedDevices={['Vizio']}
    />
  )
}

const additionalFAQs = [
  {
    question: 'Can I watch AEW All In: Texas 2025 on Fubo?',
    answer:
      'Yes, you can watch AEW All In: Texas 2025 on Fubo. It is available as a Pay Per View event.',
  },
  {
    question: 'How do I find AEW All In: Texas 2025 on Fubo?',
    answer:
      'If you ordered the AEW All In: Texas 2025 Pay Per View event, type “pay per view” in Fubo’s search bar. Or find the Pay Per View channel in Fubo’s channel guide.',
  },
  {
    question: 'Can I watch AEW commentary and analysis on Fubo?',
    answer:
      'Yes, if you order the Pay Per View you will have access Pay Per View preshow and other content. Get all the storyline updates, interviews and analysis you’ll need before the event.',
  },
  {
    question: 'Will AEW All In: Texas 2025 be replayed on Fubo?',
    answer:
      'Yes, if you miss the event or want to watch it again, AEW All In: Texas 2025 will be available to replay for a period of time after the event ends.',
  },
  {
    question: 'What related AEW content can I find on Fubo?',
    answer:
      'If you like AEW, you’ll love the variety of pro wrestling, boxing and other combat sports on Fubo. With a Fubo subscription you can watch WWE, UFC, BKFC and more. Plus behind-the-scenes shows and special events for fans of every sport and league.',
  },
]
